<template>
  <li
    v-for="(parent, index) in parentCategories"
    :key="parent"
    :class="{ 'is-last': index === Object.keys(parentCategories).length - 1 }"
    class="list-item f"
  >
    <button
      :class="{ open: activeCategory === parent }"
      class="category f"
      role="button"
      @click.stop="emit('open', parent)"
    >
      <span class="category-name">{{ t(`categories.${parent}`) }}</span>
      <i class="i-arrow category-arrow" />
    </button>
    <ul
      :class="{ open: activeCategory === parent }"
      class="category-dropdown"
    >
      <li
        v-if="parent !== 'Other'"
        class="category-item"
      >
        <NuxtLink
          :to="getAllWeaponsPageLink(parent || '')"
          class="category-link-all f"
        >
          <div class="category-link-all-images">
            <img
              v-for="item in (innerCategories[parent.toLowerCase()] as Item[]).slice(-4)"
              :key="item?.full_name + item?.weapon"
              :src="getImageFromWaxpeer(item?.full_name || '', '60:60')"
              alt=""
              class="link-icon"
              height="24"
              loading="lazy"
              width="24"
            >
          </div>
          <span class="link-name">{{ $t(`filters.weapon.all.${parent}`) }}</span>
        </NuxtLink>
      </li>
      <li
        v-for="inner in innerCategories[parent.toLowerCase()]"
        :key="inner.full_name"
        class="category-item"
        @click="emit('close')"
      >
        <CategoriesCategoryLink
          :fullname="inner?.full_name || ''"
          :weapon="inner?.weapon || ''"
        />
      </li>
      <template v-if="parent === 'Other'">
        <li
          v-for="inner in equipmentItems"
          :key="inner.full_name"
          class="category-item"
          @click="emit('close')"
        >
          <CategoriesCategoryLink
            :fullname="inner?.full_name || ''"
            :weapon="inner?.weapon || ''"
          />
        </li>
      </template>
    </ul>
  </li>
</template>

<script lang="ts" setup>
import type { Item } from '~/graphql/generated/schema-types';
import { getAllWeaponsPageLink } from '~/utils/name-utils';

const props = defineProps<{
  categories: Item[]
  activeCategory: string | null
  equipmentItems: Item[]
}>();

const emit = defineEmits<{
  (e: 'open', category: string): void
  (e: 'close'): void
}>();
const { t } = useI18n();

const parentCategories = ['cosmetics', 'containers', 'Other'];

const innerCategories = computed<Record<string, Item[]>>(() => {
  return {
    cosmetics: ['Stickers', 'Weapon Charms', 'Graffities', 'Music Kits', 'Patches'].map(
      category => props.categories.find(item => item.weapon === category) || ({} as Item),
    ),
    containers: [
      'Case',
      'Crates',
      'Autograph Capsule',
      'Patch Capsule',
      'Sticker Capsule',
      'Music Kit Box',
      'Graffiti',
      'Souvenir',
      'Pins',
    ].map(category => props.categories.find(item => item.weapon === category) || ({} as Item)),
    other: [
      ...['Agents', 'Keys', 'Tools', 'Collectibles'].map(
        category => props.categories.find(item => item.weapon === category) || ({} as Item),
      ),
      // {
      //   full_name: 'tournaments',
      //   weapon: 'tournaments',
      //   image: getImageFromProxy(siteHost + '/img/trophy.png', '50:50'),
      // },
      // {
      //   full_name: 'teams',
      //   weapon: 'teams_label',
      //   image: getImageFromProxy(siteHost + '/img/trophy-teams.png', '50:50'),
      // },
      // {
      //   full_name: 'markets',
      //   weapon: 'all_markets',
      //   image: getImageFromProxy(siteHost + '/img/markets.svg', '50:50'),
      // },
      // {
      //   full_name: 'collections',
      //   weapon: 'Collections',
      //   image: getImageFromProxy(siteHost + '/img/collections.png', '50:50'),
      // },
    ] as Item[],
  };
});
</script>

<style lang="scss" scoped>
.list-item {
  min-width: auto;
  font-size: 1.5rem;
  position: relative;
  cursor: pointer;

  .category {
    padding: 0.1rem 0.8rem;
    height: 100%;
  }

  .category-name {
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;

    font-weight: 600;
    font-size: 1.4rem;
    line-height: 1.9rem;
    color: var(--surfaces-on-surface-variable);
  }

  .category-arrow {
    margin-left: 1rem;
    font-size: 1rem;
    color: var(--surfaces-on-surface);
    opacity: 0.3;
  }

  .category-dropdown {
    position: absolute;
    top: 4.8rem;
    background: var(--surfaces-low-container);
    box-shadow: 0 4px 20px rgba(26, 26, 26, 0.7);
    //border-radius: 1.2rem;
    //padding: 0 0.3rem;
    overflow-y: auto;
    min-width: 22rem;
    transition: all 0.3s;
    max-height: 0;
    max-width: max-content;
    width: max-content;

    background: var(--surfaces-container);
    //background: red;
    font-size: 14px;
    padding: 0;
    border-radius: 12px;

    /* width */
    &::-webkit-scrollbar {
      width: 12px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      padding: 4px;
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: var(--surfaces-outline);
      border-radius: 4px;
      border: 4px solid transparent; // Создает эффект узкого `thumb`
      background-clip: padding-box; // Центрирует `thumb` внутри скроллбара
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background-color: color-mix(IN srgb, var(--surfaces-outline) 95%, white);
    }

    //.category-item {
    //margin-bottom: -2px;
    ////display: flex;
    //padding-left: 1.2rem;
    //padding-right: 1.2rem;
    //height: 5.4rem;
    //
    //&:last-child:deep(.category-link) {
    //  border-bottom: none;
    //}

    //&:hover {
    //  background: #1d212b;
    //}
    //}
  }

  .category-link-all {
    display: inline-flex;
    align-items: center;
    padding: 4px 16px;
    width: 100%;
    gap: 16px;
    border-radius: 0 8px 8px 0;

    .category-link-all-images {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: center;
      width: 50px;
      height: 50px;
      flex-shrink: 0;
      flex-grow: 0;

      background: radial-gradient(
              50% 50% at 50% 50%,
              color-mix(in srgb, var(--accent-on-surface) 40%, transparent) 0%,
              transparent 100%
      );

      img {
        object-fit: cover;
      }
    }

    .link-name {
      font-weight: 400;
      font-size: 1.4rem;
      color: var(--surfaces-on-surface-variable);
      //margin-left: 1.5rem;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 100%;
      display: inline-block;
      text-align: left;
      line-height: 5rem;
    }

    &:hover,
    &.router-link-exact-active {
      background: color-mix(IN srgb, var(--surfaces-container) 95%, white);

      .link-name {
        color: var(--accent-secondary);
      }
    }
  }

  &.is-last .category-dropdown {
    right: 0;
    left: unset;
  }

  .open {
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
    max-height: 43.8rem;
  }
}

.open .category-arrow {
  transform: rotate(180deg);
}

@media screen and (max-width: 1115px) {
  .list-item {
    width: 100%;
    padding-left: 2.5rem;
    padding-right: 3.65rem;
    display: flex;
    flex-direction: column;

    .category {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0;
    }

    .category-dropdown {
      position: initial;
      top: initial;
      background: none;
      box-shadow: none;
      padding: 0;
      overflow-y: hidden;
      width: 100%;
      margin-top: 1.1rem;

      .category-item {
        margin-bottom: 0;
        padding-left: 0;
        padding-right: 0;
        height: unset;

        &:hover {
          background: none;
        }

        &:hover .link-name {
          color: var(--surfaces-on-surface);
        }

        .link-name {
          line-height: 2.8rem;
        }
      }
    }

    .open {
      max-height: 100rem;
    }

    .open .category-name {
      color: var(--surfaces-on-surface);
    }

    .open .category-arrow {
      color: var(--surfaces-on-surface);
      opacity: 1;
    }
  }
}
</style>
